module.exports = __webpack_public_path__ + "img/logo_2.b25a4ed7.png";